// extracted by mini-css-extract-plugin
export var intro = "intro-module--intro--2B3T1";